import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetAllAssets, useGetManufacturerById } from "../../hooks";
import { ManufacturerAssets } from "./manufacturerAssets";
import { ManufacturerProfile } from "./manufacturerProfile";

export const ManufacturerLanding = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: manufacturer } = useGetManufacturerById(Number(id));
  const { data: assets } = useGetAllAssets(Number(id));

  const getStatusColor = (status: boolean) => {
    return status === true
      ? "bg-green-100 text-green-800"
      : "bg-gray-100 text-gray-800";
  };

  if (!id) {
    return (
      <div className="p-6">
        <h2 className="text-2xl font-bold text-gray-900">
          Manufacturer not found
        </h2>
        <Button
          onClick={() => navigate("/ax/settings/manufacturers")}
          className="mt-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Manufacturers
        </Button>
      </div>
    );
  }

  const tabComponents = {
    assets: {
      label: "Assets",
      shortLabel: "Assets",
      component: <ManufacturerAssets />,
    },
    // inventory: {
    //   label: "Inventory",
    //   shortLabel: "Inventory",
    //   component: <ManufacturerInventory manufacturer={manufacturer} />,
    // },
  };

  const urlMapping = {
    assets: "assets",
    inventory: "inventory",
  };

  return (
    <div>
      <div className="space-y-6 p-4">
        {/* Header Section */}
        <div className="mb-4 flex items-center gap-4">
          {/* Back Arrow */}
          <ArrowLeft
            className="w-5 h-5 cursor-pointer text-gray-700"
            onClick={() => navigate("/ax/settings/manufacturers")}
          />

          {/* Title + Badge */}
          <div className="flex flex-col">
            <PageHeader
              title={manufacturer?.name}
              subtitle={manufacturer?.manufacturerNo}
            />
          </div>
        </div>

        {/* Manufacturer Profile Section - Always Visible */}
        <ManufacturerProfile
          manufacturerId={id}
          manufacturer={manufacturer}
          assets={assets}
        />

        {/* Tabbed Interface for Assets and Inventory */}
        <Tabs
          defaultValue="assets"
          urlMapping={urlMapping}
          tabComponents={tabComponents}
          // tabsListClassName="grid w-full grid-cols-2 mb-6"
          // idPrefix="manufacturer-tab"
          level={0} // Top-level tabs
        />
      </div>
    </div>
  );
};
